import { render, staticRenderFns } from "./DetailCustomerReport.vue?vue&type=template&id=b6a9f04c&scoped=true"
import script from "./DetailCustomerReport.vue?vue&type=script&lang=js"
export * from "./DetailCustomerReport.vue?vue&type=script&lang=js"
import style0 from "./DetailCustomerReport.vue?vue&type=style&index=0&id=b6a9f04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a9f04c",
  null
  
)

export default component.exports